import { useEffect, useState } from "react";
import DashboardLayout from '../Layout/Index'
import ReviewTable from '../components/tables/ReviewTable'
import ReviewDrawer from '../Modals/ReviewDrawer'
import { FiSearch } from "react-icons/fi";

import { useDispatch, useSelector } from "react-redux";
import { fetchReview } from "../redux/slices/reviewSlice";
import { SelectDropDown } from "../components/SelectDropdown";


const Ratings = () => {
  const itemsPerPage = 10;
  const dispatch = useDispatch();

  const [value, setValue] = useState("agent");
  const [starValue, setStarValue] = useState("5");
  const [searchTerm, setSearchTerm] = useState("");

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); 
  const [totalRecord, setTotalRecord] = useState(0);

  const Rating  = useSelector(state => state?.review)
  
  useEffect(()=>{
    dispatch(fetchReview({
      searchText: searchTerm,
      pageSize: itemsPerPage,
      pageNumber: currentPage,
    }
    ))
  }, [dispatch, searchTerm, currentPage,])

  useEffect(() => {
    if(Rating){
      setTotalRecord(Rating?.overview?.totalRecord);
    }
  },[Rating]);

  const data = Rating?.overview?.data;

  const SelectedOption = [
    { label: "Delivery Agent", value: "agent" },
    { label: "Food Item", value: "food" },
  ];

  const SelectedOptionStars = [
    { label: "5 Stars", value: "5" },
    { label: "4 Stars", value: "4" },
    { label: "3 Stars", value: "3" },
    { label: "2 Stars", value: "2" },
    { label: "1 Stars", value: "1" },
  ];

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setIsDrawerOpen(true);
  };

  const handleChange = (selectedOption) => {
    setValue(selectedOption.value);
  }
  const handleChangeStar = (selectedOptionStatrs) => {
    setStarValue(selectedOptionStatrs.value);
    console.log(selectedOptionStatrs.value)
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <DashboardLayout>
      <div className="px-6 sm:px-8 pt-5 py-10 bg-white w-full mt-16">
        <div className="bg-white px-2 py-3">
          <h1 className="text-2xl font-bold text-[#FF0000] pb-2">Customer Ratings & Reviews</h1>
          <p className="text-sm text-[#0A0A0ACC]">
          Discover valuable feedback from customers to enhance service quality. Track ratings for delivery agents and popular dishes to keep our standards high and customers satisfied.
          </p>
        </div>
        <div className="h-[1px] w-full border-0 bg-primaryGray my-4 shadow-md" />
        <ReviewDrawer />
        <div className="flex flex-col md:flex-row md:items-center justify-between px-4 py-6 bg-white shadow-xl">
          <div className="relative">
            <input
              type="search"
              name="search"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search by Entity"
              className="bg-[#F9F9F9] px-12 py-3 rounded-2xl w-[350px] ring-0 outline-none text-sm"
            />
            <FiSearch className="absolute left-4 top-3 text-lg text-[#A6A9B9]" />
          </div>
          <div className="flex items-center justify-between gap-x-10 mt-5 md:mt-0">
            <div className="flex items-center">
              <p className="text-sm font-semibold pr-2">Review Type </p>
              <SelectDropDown options={SelectedOption} 
                onSelect={handleChange} 
              />
            </div>
            <div className="flex items-center">
            <p className="text-sm font-semibold pr-2">Rating</p>
            <SelectDropDown options={SelectedOptionStars} 
                onSelect={handleChangeStar} 
              />
            </div>
        </div>
        </div>
        <ReviewTable
          onRowClick={handleRowClick}
          searchTerm={searchTerm} 
          data={data} 
          itemsPerPage={itemsPerPage} 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={Rating?.loading}
          totalRecord={totalRecord}
        />
        <ReviewDrawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          item={selectedItem}
        />
      </div>
    </DashboardLayout>
  )
}

export default Ratings